/* RSC Health  -  Collection page: category chip filtering (client-side, over the rendered
   cards) + live count. Native sort is handled by the ?sort_by <select> in the section.
   Add-to-cart is the global rsc-atc.js handler. No PHI. */
(function () {
  'use strict';
  var root = document.querySelector('[data-rsc-collection]');
  if (!root) return;
  var chips = root.querySelector('[data-rsc-chips]');
  var grid = root.querySelector('[data-rsc-grid]');
  var countEl = root.querySelector('[data-rsc-count]');
  if (!chips || !grid) return;

  var cards = Array.prototype.slice.call(grid.querySelectorAll('.pcard'));

  function apply(filter) {
    var shown = 0;
    cards.forEach(function (c) {
      var match = filter === 'all' || c.getAttribute('data-group') === filter;
      c.classList.toggle('is-hidden', !match);
      if (match) shown++;
    });
    if (countEl) {
      var noun = countEl.getAttribute('data-noun') || 'tests';
      var singular = noun === 'results' ? 'result' : 'test';
      countEl.textContent = shown + ' ' + (shown === 1 ? singular : noun);
    }
  }

  chips.addEventListener('click', function (e) {
    var btn = e.target.closest('.fchip');
    if (!btn) return;
    chips.querySelectorAll('.fchip').forEach(function (x) { x.classList.toggle('on', x === btn); });
    apply(btn.getAttribute('data-filter'));
  });
})();
